"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var priceFormat = function priceFormat(price) {
  var showComma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var priceToParse = typeof price === "string" ? price.replace(",", ".") : price;
  return showComma ? parseFloat(priceToParse).toFixed(2).replace(".", ",") : parseFloat(priceToParse).toFixed(2);
};
var _default = priceFormat;
exports["default"] = _default;